import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

// material-ui components
import { TableBody, TableHead, TableRow } from '@mui/material';

import CloudDownload from '@mui/icons-material/CloudDownload';
import { DenseHeaderTableCell, TableStyled } from './DocumentsStyles';
import { IconButton } from '@totalsoft/rocket-ui';

const DocumentsExportHistoryComponent = ({ t, documentHistory, downloadFile }) => {
  return (
    <>
      <div style={{ width: '100%' }}>
        <TableStyled>
          <TableHead>
            <TableRow>
              <DenseHeaderTableCell>{t('OfferEdit.Documents.History.FileVersion')}</DenseHeaderTableCell>
              <DenseHeaderTableCell>{t('OfferEdit.Documents.History.SharePointFileName')}</DenseHeaderTableCell>
              <DenseHeaderTableCell>{t('OfferEdit.Documents.History.ExportDate')}</DenseHeaderTableCell>
              <DenseHeaderTableCell>{t('OfferEdit.Documents.History.ExportedBy')}</DenseHeaderTableCell>
              <DenseHeaderTableCell></DenseHeaderTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {documentHistory?.map(n => {
              return (
                <TableRow key={n.fileId}>
                  <DenseHeaderTableCell>{n.version}</DenseHeaderTableCell>
                  <DenseHeaderTableCell>{n.sharepointFileName}</DenseHeaderTableCell>
                  <DenseHeaderTableCell>
                    {t('DATE_FORMAT', { date: { value: n.exportedDate, format: 'DD.MM.YYYY HH:mm:ss' } })}
                  </DenseHeaderTableCell>
                  <DenseHeaderTableCell>{n.exportedBy}</DenseHeaderTableCell>
                  <DenseHeaderTableCell>
                    <IconButton variant='text' onClick={downloadFile(n.fileId)} tooltip={t('Tooltips.Download')}>
                      <CloudDownload />
                    </IconButton>
                  </DenseHeaderTableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </TableStyled>
      </div>
    </>
  );
};

DocumentsExportHistoryComponent.propTypes = {
  t: PropTypes.func.isRequired,
  documentHistory: PropTypes.array,
  downloadFile: PropTypes.func.isRequired
};

export default withTranslation()(DocumentsExportHistoryComponent);
